<template>
    <div>
        <section id="roi" class="py-24 bg-gray-900 text-white rounded-t-[3rem] -mt-6 z-20 relative">
            <div class="max-w-7xl mx-auto px-4">
                <div class="text-center mb-16">
                    <h2 class="text-3xl md:text-4xl font-bold">Pourquoi choisir Termoflow ?</h2>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
                    <div class="bg-gray-800 p-8 rounded-2xl border border-gray-700 hover:border-orange-500 transition-colors duration-300">
                        <div class="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center text-orange-500 text-2xl mb-6">
                            <i class="fa-solid fa-stopwatch"></i>
                        </div>
                        <h4 class="text-xl font-bold mb-2">Gain de temps</h4>
                        <p class="text-gray-400 text-sm mb-4">Moins de saisie manuelle, automatisation des rapports.</p>
                        <p class="text-orange-400 font-bold text-sm">Economie de +4h / semaine / technicien</p>
                    </div>
                    <div class="bg-gray-800 p-8 rounded-2xl border border-gray-700 hover:border-orange-500 transition-colors duration-300">
                        <div class="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center text-orange-500 text-2xl mb-6">
                            <i class="fa-solid fa-scale-balanced"></i>
                        </div>
                        <h4 class="text-xl font-bold mb-2">Conformité Totale</h4>
                        <p class="text-gray-400 text-sm mb-4">CERFA toujours à jour, traçabilité des fluides sans faille.</p>
                        <p class="text-orange-400 font-bold text-sm">Aucun risque d'amende</p>
                    </div>
                    <div class="bg-gray-800 p-8 rounded-2xl border border-gray-700 hover:border-orange-500 transition-colors duration-300">
                        <div class="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center text-orange-500 text-2xl mb-6">
                            <i class="fa-solid fa-wallet"></i>
                        </div>
                        <h4 class="text-xl font-bold mb-2">Rentabilité</h4>
                        <p class="text-gray-400 text-sm mb-4">Vos techniciens ne perdent plus de temps sur des tâches administratives, ils peuvent se concentrer sur de nouvelles interventions.</p>
                        <p class="text-orange-400 font-bold text-sm">ROI immédiat</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>